// Mur d'abonnement (brique S3) — écran de blocage affiché quand l'accès n'est plus actif
// (essai terminé ou abonnement à renouveler). Deux issues : aller s'abonner (Réglages ›
// Mon abonnement) ou se déconnecter. La sécurité réelle est côté serveur (middlewareAcces) ;
// cet écran en est l'équivalent visuel pour l'utilisatrice.

import { useAuth } from '@/lib/auth'

export default function MurAbonnement({ onSabonner }: { onSabonner: () => void }) {
  const { logout } = useAuth()
  return (
    <div className="min-h-screen bg-bdspBg flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-2xl border border-amber-200 bg-white p-6 shadow-sm">
        <h1 className="text-xl font-semibold text-bdspInk">Accès suspendu</h1>
        <p className="mt-3 text-sm text-stone-600">
          Ton essai gratuit est terminé, ou ton abonnement est à renouveler. Pour continuer à
          utiliser BD-CosPro (création et modifications), choisis une formule.
        </p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={onSabonner}
            className="rounded-lg bg-bdspIndigo px-4 py-2 text-sm font-semibold text-white transition hover:opacity-90"
          >
            Voir les formules
          </button>
          <button
            type="button"
            onClick={() => void logout()}
            className="rounded-lg border border-stone-300 bg-white px-4 py-2 text-sm font-medium text-bdspInk transition hover:bg-stone-50"
          >
            Se déconnecter
          </button>
        </div>
      </div>
    </div>
  )
}
